import { type RefObject, useState } from 'react'
import { useReactToPrint } from 'react-to-print'

import { type PackingListPageSize, packingListPageStyle } from '@/components/stickers/packing-list-document'

/** Paper size for the preview and the print; picking one only switches it — Print prints. */
export function usePackingListPrint(contentRef: RefObject<HTMLDivElement | null>, onAfterPrint?: () => void) {
  const [pageSize, setPageSize] = useState<PackingListPageSize>('label')

  const print = useReactToPrint({
    contentRef,
    pageStyle: packingListPageStyle(pageSize),
    onAfterPrint,
    suppressErrors: process.env.NODE_ENV !== 'production'
  })

  return { pageSize, print, setPageSize }
}
